import { array, schema, string } from "@anna-money/anna-web-lib/serializer";

export class NationalitiesData extends schema(
  {
    nationalities: array(string()),
  },
  "NationalitiesData",
) {}
